module.exports = __webpack_public_path__ + "img/vaccination_badge_30.8d271d62.png";